var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E9F8F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7846 32.7629L33.1642 21.1425C32.7983 20.7764 32.2046 20.7764 31.8384 21.1425L20.218 32.7628C20.0422 32.9386 19.9434 33.1771 19.9434 33.4257V44.5521C19.9434 46.4533 21.4901 47.9999 23.3913 47.9999H29.4889C30.0066 47.9999 30.4264 47.5802 30.4264 47.0624V39.9666H34.5764V47.0625C34.5764 47.5803 34.9961 48 35.5139 48H41.6114C43.5125 48 45.0592 46.4533 45.0592 44.5521V33.4258C45.0592 33.1771 44.9605 32.9387 44.7846 32.7629Z",
    fill: "#083E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7852 32.7629L33.1648 21.1425C32.9818 20.9594 32.7419 20.8679 32.502 20.8679V39.9666H34.577V47.0625C34.577 47.5802 34.9967 48 35.5145 48H41.612C43.5131 48 45.0598 46.4533 45.0598 44.5521V33.4258C45.0598 33.1771 44.9611 32.9387 44.7852 32.7629Z",
    fill: "#083E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1182 16H39.1016C38.5838 16 38.1641 16.4197 38.1641 16.9375V22.7018C38.1641 22.9505 38.2628 23.1889 38.4387 23.3647L42.4554 27.3813C42.6348 27.5607 42.8745 27.6559 43.1184 27.6559C43.2393 27.6559 43.3611 27.6326 43.477 27.5846C43.8273 27.4394 44.0557 27.0976 44.0557 26.7184V16.9375C44.0557 16.4197 43.6361 16 43.1182 16Z",
    fill: "#179D82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6355 29.9112L34.5893 16.8651C34.0314 16.3073 33.2896 16 32.5006 16C31.7116 16 30.9698 16.3073 30.4119 16.8651L17.3658 29.9114C16.214 31.063 16.214 32.937 17.3658 34.0887C17.9237 34.6466 18.6655 34.9539 19.4545 34.9539C20.2435 34.9539 20.9853 34.6466 21.5431 34.0886L32.5006 23.1312L43.4581 34.0887C44.016 34.6466 44.7576 34.9538 45.5466 34.9539H45.5468C46.3356 34.9539 47.0774 34.6466 47.6355 34.0886C48.7872 32.9369 48.7872 31.0629 47.6355 29.9112Z",
    fill: "#179D82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6348 29.9112L34.5887 16.8651C34.0308 16.3073 33.289 16 32.5 16V23.1312L43.4574 34.0887C44.0153 34.6466 44.757 34.9538 45.5459 34.9539H45.5461C46.335 34.9539 47.0767 34.6466 47.6348 34.0886C48.7866 32.9369 48.7866 31.0629 47.6348 29.9112Z",
    fill: "#179D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/consultation.f59764d06d5159c384e098e9b2ebb538.svg";
export { ForwardRef as ReactComponent };